module.exports = __webpack_public_path__ + "img/logow_white.a5bc41c4.png";